import { render, staticRenderFns } from "./ClientCampaignView.vue?vue&type=template&id=0351c984&scoped=true"
import script from "./ClientCampaignView.vue?vue&type=script&lang=js"
export * from "./ClientCampaignView.vue?vue&type=script&lang=js"
import style0 from "./ClientCampaignView.vue?vue&type=style&index=0&id=0351c984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351c984",
  null
  
)

export default component.exports